import { fourierConfig as config } from "./config";

export const clamp01 = (n: number) => Math.max(0, Math.min(1, n));
export const ease = (n: number) => {
  const t = clamp01(n);
  return t * t * (3 - 2 * t);
};
export type FilmTiming = {
  intro: number;
  stages: readonly number[];
  outro: number;
  hold: number;
  crossfade: number;
  focusDelay: number;
  focusDuration: number;
};
export const getTimeline = (frame: number, fps: number, timing: FilmTiming = config.timing) => {
  const introFrames = Math.round(timing.intro * fps);
  if (frame < introFrames)
    return {
      kind: "intro" as const,
      index: 0,
      localFrame: frame,
      progress: frame / Math.max(1, introFrames - 1),
    };
  let start = introFrames;
  for (let index = 0; index < timing.stages.length; index++) {
    const duration = Math.round(timing.stages[index] * fps);
    if (frame < start + duration)
      return {
        kind: "drawing" as const,
        index,
        localFrame: frame - start,
        progress: clamp01(
          (frame - start) /
            Math.max(1, duration - 1 - Math.round(timing.hold * fps)),
        ),
      };
    start += duration;
  }
  return {
    kind: "outro" as const,
    index: timing.stages.length - 1,
    localFrame: frame - start,
    progress: 1,
  };
};

/** Completed contours move from the right panel to the central hero position. */
export const getTrailLayout = (frame: number, fps: number, timing: FilmTiming = config.timing) => {
  const scene = getTimeline(frame, fps, timing);
  const focus =
    scene.kind === "outro"
      ? ease(
          (scene.localFrame / fps - timing.focusDelay) /
            timing.focusDuration,
        )
      : 0;
  const { targetX, y, scale, finish } = config.layout;
  return {
    x: targetX + (finish.x - targetX) * focus,
    y: y + (finish.y - y) * focus,
    scale: scale + (finish.scale - scale) * focus,
  };
};
